<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">Länka avvikelse</v-card-title>

      <v-card-text class="mt-2">
        <v-row>
          <v-col>
            <v-card class="d-flex pa-4">
              <div class="flex-grow-1">
                <div class="text--secondary">Avvikelse</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ item._deviation_type }}
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="text--secondary">Typ</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ item.type }}
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="text--secondary">Tågnr.</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ item.train_number }}
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="text--secondary">Från</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ item._from }}
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="text--secondary">Till</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ item._to }}
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="text--secondary">Ank.</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ item._departure }}
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="text--secondary">Avg.</div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ item._arrival }}
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="groupedEvents"
              :loading="$apollo.loading"
              :rules="[required]"
              item-value="uuid"
              item-text="title"
              outlined
              placeholder="Välj händelse att länka på..."
              label="Händelser"
              v-model="model.eventUUID"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="pending"
          >Länka</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { required } from '@/common/validationRules'
// import { get } from 'vuex-pathify'
import * as uuid from 'uuid/v4'
import { addDays, format } from 'date-fns'

export default {
  name: 'LinkDeviationTrainDeviationModal',

  props: ['item'],

  data: () => ({
    required,
    valid: true,
    pending: false,
    model: {
      eventUUID: null,
      delayReasonSlug: null
    }
  }),

  created() {
    if (
      this.item &&
      this.item.trainDeviation &&
      this.item.trainDeviation.event_uuid
    ) {
      this.model.eventUUID = this.item.trainDeviation.event_uuid
    }
  },

  apollo: {
    events: {
      query: gql`
        query events($filter: GetEventsInput!) {
          events(filter: $filter) {
            uuid
            title
          }
        }
      `,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            archived: true,
            district_id: this.$store.get('app/selectedDistrictId'),
            from: format(addDays(new Date(), -5), 'yyyy-MM-dd'),
            to: format(new Date(), 'yyyy-MM-dd')
          }
        }
      }
    },
    activeEvents: {
      fetchPolicy: 'no-cache',
      query: gql`
        query activeEvents {
          activeEvents {
            uuid
            title
            district_id
          }
        }
      `
    }
  },

  computed: {
    groupedEvents() {
      const activeEvents = (this.activeEvents || []).filter(
        ev => ev.district_id === this.$store.get('app/selectedDistrictId')
      )

      const archivedEvents = this.events || []
      return [
        ...(activeEvents.length ? [{ divider: true, header: 'Aktiva' }] : []),
        ...activeEvents,
        ...(archivedEvents.length
          ? [{ divider: true, header: 'Arkiverade' }]
          : []),
        ...archivedEvents
      ]
    }
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.pending = true

      const model = {
        uuid: uuid(),
        event_uuid: this.model.eventUUID,
        ...Object.keys(this.item)
          .filter(key => !key.startsWith('_') && key !== 'trainDeviation')
          .reduce((acc, next) => {
            acc[next] = this.item[next]
            return acc
          }, {})
      }

      if (this.item.trainDeviation) {
        this.replaceTrainDeviation(model)
      } else {
        this.createTrainDeviation(model)
      }

      this.pending = false
      this.closeModal()
      this.$emit('confirm')
    },

    async createTrainDeviation(payload) {
      const payloadCopy = { ...payload }
      delete payloadCopy.technical_number

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateTrainDeviationInput!) {
            createTrainDeviation(payload: $payload) {
              train_deviation_uuid
            }
          }
        `,
        variables: {
          payload: payloadCopy
        }
      })
    },

    async replaceTrainDeviation(payload) {
      const payloadCopy = { ...payload }
      delete payloadCopy.technical_number

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ReplaceTrainDeviationInput!) {
            replaceTrainDeviation(payload: $payload) {
              train_deviation_uuid
            }
          }
        `,
        variables: {
          payload: {
            delete_uuid: this.item.trainDeviation.uuid,
            payload: payloadCopy
          }
        }
      })
    },

    closeModal() {
      this.$store.set('linkDeviation/selectedTrainDeviation', null)
      this.$store.commit('delay/resetModel')
    }
  }
}
</script>
